import React from 'react';
import { defaultTemplate } from 'core/hoc';

const BasicQueryInput = defaultTemplate(({ id, label, type, queryUtility, propertyName, t, store, className}) => {
    const { value } = store;

    return (
        <div>
            {label && (
                <div className="form__group__label" htmlFor={id}>
                    {t(label)}
                </div>
            )}
            <input
                id={id}
                type={type}
                className={className || "input input--base input--text"}
                value={value}
                onChange={e => {
                    if(e.target.value == "" && propertyName != "search"){
                        delete queryUtility.filter[propertyName];
                    }else{
                        queryUtility.filter.set(propertyName, e.target.value);
                    }
                    store.setValue(e.target.value);
                }}
                onKeyPress={e => {
                    if (e.key === 'Enter') {
                        queryUtility.fetch();
                    }
                }}
            />
        </div>
    );
});

export default BasicQueryInput;
